import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Twitter, Heart } from "lucide-react";
import { SPECIALTIES, DOCTOR } from "../data/content";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-6 mt-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-[116px] h-[99px] rounded-xl bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center shadow-lg overflow-hidden">
                <img src="/images/logo.png" alt="" className="w-full h-full object-contain p-1" />
              </div>
              <div>
                <div className="text-white font-bold text-lg">Mental Mente Sano</div>
                <div className="text-xs text-slate-400">Atención Psiquiátrica Integral</div>
              </div>
            </Link>
            <p className="text-sm leading-relaxed text-slate-400">
              Atención médica especializada en psiquiatría y neurología. Tratamiento digno, respetuoso y con la mayor confidencialidad.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://www.facebook.com/drcesars" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-cyan-600 flex items-center justify-center transition" aria-label="Facebook">
                <Facebook size={16} />
              </a>
              <a href="https://twitter.com/dr_cesars" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-cyan-600 flex items-center justify-center transition" aria-label="Twitter">
                <Twitter size={16} />
              </a>
            </div>
          </div>

          {/* Navegación */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-base">Navegación</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-cyan-400 transition">Inicio</Link></li>
              <li><Link to="/curriculum" className="hover:text-cyan-400 transition">Currículum</Link></li>
              <li><Link to="/compromisos" className="hover:text-cyan-400 transition">Responsabilidad y Compromiso</Link></li>
              <li><Link to="/decalogo" className="hover:text-cyan-400 transition">Decálogo Médico</Link></li>
              <li><Link to="/testimonios" className="hover:text-cyan-400 transition">Testimonios</Link></li>
              <li><Link to="/enlaces" className="hover:text-cyan-400 transition">Enlaces recomendados</Link></li>
              <li><Link to="/contacto" className="hover:text-cyan-400 transition">Contacto</Link></li>
            </ul>
          </div>

          {/* Especialidades */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-base">Especialidades</h4>
            <ul className="space-y-2 text-sm">
              {SPECIALTIES.slice(0, 7).map((s) => (
                <li key={s.slug}>
                  <Link to={`/especialidades/${s.slug}`} className="hover:text-cyan-400 transition">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-base">Contacto</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-cyan-400 mt-0.5 flex-shrink-0" />
                <a href="https://maps.google.com/?q=19.5487041,-96.92388" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition">{DOCTOR.address}</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-cyan-400 flex-shrink-0" />
                <a href={`tel:${DOCTOR.phone.replace(/\s/g, "")}`} className="hover:text-cyan-400 transition">{DOCTOR.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-cyan-400 flex-shrink-0" />
                <a href={`tel:${DOCTOR.mobile.replace(/\s/g, "")}`} className="hover:text-cyan-400 transition">Cel. {DOCTOR.mobile}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-cyan-400 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${DOCTOR.email}`} className="hover:text-cyan-400 transition break-all">{DOCTOR.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-sm">
          <div className="text-slate-500 text-center md:text-left">
            © {new Date().getFullYear()} {DOCTOR.name}. Todos los derechos reservados.
          </div>
          <div className="text-slate-500 flex items-center gap-1.5">
            Hecho con <Heart size={14} className="text-rose-500 fill-rose-500" /> para el bienestar mental
          </div>
        </div>
      </div>
    </footer>
  );
}
